import HttpInterfaceMock from '../Tests/Mocks/HttpInterfaceMock';
import HttpInterfaceProduction from './HttpInterface';

const REACT_APP_FORCE_PROD_HTTP_IF = true;
export const USING_MOCKS = process.env.NODE_ENV === 'development' && !REACT_APP_FORCE_PROD_HTTP_IF;
const exportedInterfaceModule = USING_MOCKS
    ? HttpInterfaceMock
    : HttpInterfaceProduction;

export default exportedInterfaceModule;
